/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenHasPermission,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { ContactDetailsOther } from '../../resources/model/contact-details-other.model';
import {
  ContactDetailsSharedCommunicationListFormState,
  ContactDetailsSharedCommunicationListFormStateFactory,
} from '../contact-details-shared-communication-list-tab/contact-details-shared-communication-list-form.service';
import {
  ContactDetailsSharedCustomFieldsFormState,
  ContactDetailsSharedCustomFieldsFormStateFactory,
} from '../contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-form.service';

@Injectable()
export class ContactDetailsOtherFormState extends FormState<ContactDetailsOther> {
  customFieldsForm: ContactDetailsSharedCustomFieldsFormState;
  communicationForm: ContactDetailsSharedCommunicationListFormState;

  constructor(schemaFactory: BuilderFormSchemaFactory,
              customFieldsFormFactory: ContactDetailsSharedCustomFieldsFormStateFactory,
              communicationFormFactory: ContactDetailsSharedCommunicationListFormStateFactory) {
    super(schemaFactory);

    this.customFieldsForm = customFieldsFormFactory.create();
    this.communicationForm = communicationFormFactory.create();
  }

  build(other: ContactDetailsOther): void {
    this.communicationForm.build(other.communication);
    this.customFieldsForm.build(other.customFields);

    this.initSchema(other);
    this.setChildForm('communication', this.communicationForm);
    this.setChildForm('customFields', this.customFieldsForm);
  }

  protected buildSchema(_: ContactDetailsOther, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenHasPermission(BuilderPermission.Contacts.Other.CREATE_EDIT),
      children: {
        communication: native(this.communicationForm.group),
        customFields: native(this.customFieldsForm.group),
      },
    });
  }
}
